"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var CinematicCrossSell_1 = require("../components/CinematicCrossSell/CinematicCrossSell");
var targetNode = document.querySelector('.cinematic-cross-sell-v2-section');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(CinematicCrossSell_1.default, null), targetNode);
}
